import { createWebHistory, createRouter } from 'vue-router';

import {
  // initCurrentUserStateMiddleware,
  checkAccessMiddleware,
  checkUserPermission,
  checkServicePermission,
} from './middlewares';

// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.
// import Index from '@/views/Index.vue';
import Index from '@/views/Index.vue';

// const Alert = resolve =>
//   require([/i18n.global. webpackChunkName: "alert" */ '@/views/Alert/Alert.vue'], resolve);
import Alert from '@/views/Alert/Alert.vue';
const ConfiguredAlerts = () => import('@/views/Alert/ConfiguredAlerts.vue');
// import ConfiguredAlerts from '@/views/Alert/ConfiguredAlerts.vue';

const GeneratedAlerts = () => import('@/views/Alert/GeneratedAlerts.vue');
// import GeneratedAlerts from '@/views/Alert/GeneratedAlerts.vue';

const NotificationChannels = () =>
  import('@/views/Alert/NotificationChannels.vue');

import AlertsV2 from '@/views/AlertsV2/Alert.vue';
const ConfiguredAlertsV2 = () =>
  import('@/views/AlertsV2/ConfiguredAlerts.vue');

const GeneratedAlertsV2 = () => import('@/views/AlertsV2/GeneratedAlerts.vue');

const TagGrouping = () => import('@/views/AlertsV2/TagGrouping.vue');

// import Notification from '@/views/Notification/Notification.vue';
const ExternalTagGrouping = () =>
  import('@/views/AlertsV2/ExternalTagGrouping.vue');

const NotificationChannelsV2 = () =>
  import('@/views/Notification/NotificationChannelsV2.vue');

// import NotificationChannels from '@/views/Alert/NotificationChannels.vue';

//APM imports
import Apm from '@/views/APM/APM.vue';
// const Apm = resolve =>
//   require([/* webpackChunkName: "dashboard" */ '@/views/APM/APM.vue'], resolve);

const Dashboard = () => import('@/views/APM/Dashboard.vue');

// import Dashboard from '@/views/APM/Dashboard.vue';
const Profile = () => import('@/views/APM/Profile.vue');

// import Profile from '@/views/APM/Profile.vue';
const Trace = () => import('@/views/APM/Trace.vue');
// import Trace from '@/views/APM/Trace.vue';

const Topology = () => import('@/views/APM/Topology.vue');

// import Topology from '@/views/APM/Topology.vue';

// import DashboardService from '@/components/APM/Dashboard/Dashboard-service-graphs.vue';
const DashboardService = () =>
  import('@/components/APM/Dashboard/Dashboard-service-graphs.vue');
const DashboardAppDb = () =>
  import('@/components/APM/Dashboard/DashboardAppDbGraphs.vue');
const OverallInstance = () =>
  import('@/components/APM/Dashboard/DashboardAppDbOverall.vue');
// import OverallInstance from '@/components/APM/Dashboard/DashboardAppDbOverall.vue';
const QueryInstance = () =>
  import('@/components/APM/Dashboard/DashboardAppDbQuery.vue');
// import QueryInstance from '@/components/APM/Dashboard/DashboardAppDbQuery.vue';
// import DashboardAppDb from '@/components/APM/Dashboard/DashboardAppDbGraphs.vue';
const DashboardEndpointView = () =>
  import('@/components/APM/Dashboard/Endpoint/DashboardEndpoint.vue');
const DashboardEndpointGraphsView = () =>
  import('@/components/APM/Dashboard/Endpoint/DashboardEndpointGraphs.vue');
const DashboardEndpointTableView = () =>
  import('@/components/APM/Dashboard/Endpoint/DashboardEndpointTable.vue');

const DashboardInstanceView = () =>
  import('@/components/APM/Dashboard/Instance/DashboardInstance.vue');
const DashboardInstanceGraphsView = () =>
  import('@/components/APM/Dashboard/Instance/DashboardInstanceGraphs.vue');
const DashboardInstanceTableView = () =>
  import('@/components/APM/Dashboard/Instance/DashboardInstanceTable.vue');
const Usage = () => import('@/views/Billing&Usage/BillingUsage.vue');
const UsageDashboard = () => import('@/views/Billing&Usage/UsageDashboard.vue');
const LicenseUsage = () => import('@/views/Billing&Usage/LicenseUsage.vue');
const LicenseOverview = () =>
  import('@/components/Billing&usage/LicenseUsage/LicenseOverview.vue');
const LicenseDatasetLevel = () =>
  import('@/components/Billing&usage/LicenseUsage/LicenseDatasetInfo.vue');
const LicenseSessionLevel = () =>
  import('@/components/Billing&usage/LicenseUsage/LicenseSessionLevelInfo.vue');
const LicenseEndpointLevel = () =>
  import('@/components/Billing&usage/LicenseUsage/LicenseEndpointInfo.vue');
//Settings imports
// const Settings = resolve =>
//   require([
//     /* webpackChunkName: "setting" */ '@/views/Settings/Settings.vue'
//   ], resolve);
const GeneralSettings = () => import('@/views/Settings/GeneralSettings.vue');
const GeneralToken = () => import('@/components/Settings/access-token.vue');
const GeneralAccount = () => import('@/components/Settings/account.vue');
const GeneralTimezone = () => import('@/components/Settings/time-zone.vue');
const ServiceSettings = () => import('@/views/Settings/ServiceSettings.vue');
const TraceRetentionConfig = () =>
  import('@/views/Settings/TraceRetentionConfig.vue');
const CustomQuery = () => import('@/views/Settings/CustomQueryOverview.vue');

const DBQueryConfig = () => import('@/views/Settings/DBQueryConfig.vue');

const ApdexConfig = () => import('@/components/Settings/apdex-config.vue');
const DataRetentionConfig = () =>
  import('@/views/Settings/DataRetentionConfig.vue');
const TransactionNaming = () =>
  import('@/components/Settings/transaction-naming/TransactionNamingComp.vue');

const TransactionExclusion = () =>
  import(
    '@/components/Settings/transaction-naming/TransactionExclusionComp.vue'
  );

const CodeProfileComp = () =>
  import('@/components/Settings/code-profile/CodeProfileComp.vue');

const CodeProfileTable = () =>
  import('@/components/Settings/code-profile/CodeProfileTable.vue');

const DashboardInfraView = () =>
  import('@/components/APM/Dashboard/Infra/DashboardInfra.vue');

const DashboardInfraTableView = () =>
  import('@/components/APM/Dashboard/Infra/DashboardInfraTable.vue');

const DashboardInfraDetails = () =>
  import('@/components/APM/Dashboard/Infra/DashboardInfraDetails.vue');

import Settings from '@/views/Settings/Settings.vue';
// import GeneralSettings from '@/views/Settings/GeneralSettings.vue';
// import ServiceSettings from '@/views/Settings/ServiceSettings.vue';
//browser imports
// const Browser = resolve =>
//   require([
//     /* webpackChunkName: "browser" */ '@/views/Browser/Browser.vue'
//   ], resolve);
// import Browser from '@/views/Browser/Browser.vue'

//Home page
// const Home = resolve =>
//   require([/* webpackChunkName: "index" */ '@/views/Home/Home.vue'], resolve);
import Home from '@/views/Home/Home.vue';

// User
const IndexLogin = () => import('@/views/User/Index.vue');
const Login = () => import('@/views/User/Login.vue');
const PasswordRecover = () => import('@/views/User/PasswordRecover.vue');
const PasswordReset = () => import('@/views/User/PasswordReset.vue');
const PasswordFirst = () => import('@/views/User/PasswordFirst.vue');

import Browser from '@/views/Browser/Browser.vue';
const BrowserApplication = () =>
  import('@/components/Browser/Application/Application.vue');
const BrowserPages = () => import('@/components/Browser/Pages/Pages.vue');
const BrowserErrors = () => import('@/components/Browser/Errors/Errors.vue');

const BrowserErrosTable = () =>
  import('@/components/Browser/Errors/ErrorsTable.vue');
const BrowserEventsTable = () =>
  import('@/components/Browser/Errors/EventsTable.vue');
const BrowserSummary = () =>
  import('@/components/Browser/Errors/Details/ErrorDetails.vue');
const BrowserPagesTable = () =>
  import('@/components/Browser/Pages/PagesTable.vue');

const BrowserPagesGraphs = () =>
  import('@/components/Browser/Pages/PagesGraphs.vue');

import Database from '@/views/Database/Database.vue';
import VM from '@/views/VM/VM.vue';
// Disabled WSM as currently it is not supported
// import WSM from '@/views/WSM/WSM.vue';
import { k8mRoutes } from '@/router/capability/k8m';
import { integrations } from '@/router/capability/integrations';
import { cloud } from '@/router/capability/cloud';
import { vmRoutes } from '@/router/capability/vm';
import { smRoutes } from '@/router/capability/sm';
import { logRoutes } from '@/router/capability/log';
import { analyticsRoutes } from '@/router/capability/analytics';
import { DERoutes } from '@/router/capability/de';
import { mqRoutes } from '@/router/capability/mq';
import { commonRoutes } from '@/router/capability/common';

const VMOverview = () => import('@/components/VM/VMOverview.vue');

const VMDetails = () => import('@/components/VM/VMDetails.vue');

import MOBILE from '@/views/Mobile/Mobile.vue';

const MblDashboard = () =>
  import('@/components/Mobile/Dashboard/MblDashboard.vue');

const KPIs = () => import('@/components/Mobile/KPIs/KPIs.vue');

const UsageKPIs = () => import('@/components/Mobile/KPIs/Usage/Usage.vue');

const usageGraphs = () =>
  import('@/components/Mobile/KPIs/Usage/UsageGraphs.vue');

const crashesOverview = () =>
  import('@/components/Mobile/KPIs/Crashes/CrashesTables/CrashesOverview.vue');
const crashesEventsOverview = () =>
  import('@/components/Mobile/KPIs/Crashes/CrashesTables/CrashEvents.vue');
const crashesEventSummary = () =>
  import('@/components/Mobile/KPIs/Crashes/CrashesTables/CrashSummary.vue');
const crashesGraphs = () =>
  import('@/components/Mobile/KPIs/Crashes/CrashesGraphs.vue');
const CrashKPIs = () => import('@/components/Mobile/KPIs/Crashes/Crashes.vue');

const CrashesTopOverview = () =>
  import('@/components/Mobile/KPIs/Crashes/CrashesTables/TopLocations.vue');

const CrashesTopLocSummary = () =>
  import(
    '@/components/Mobile/KPIs/Crashes/CrashesTables/TopLocationsSummary.vue'
  );

const PerformanceKPIs = () =>
  import('@/components/Mobile/KPIs/Performance/Performance.vue');

const performanceGraphs = () =>
  import('@/components/Mobile/KPIs/Performance/PerformanceGraphs.vue');

const httpReqOverview = () =>
  import(
    '@/components/Mobile/KPIs/Performance/PerformanceTables/HttpReqOverview.vue'
  );

const httpRequestsSummary = () =>
  import(
    '@/components/Mobile/KPIs/Performance/PerformanceTables/HttpReqSummary.vue'
  );

const PerfTopLocationsOverview = () =>
  import(
    '@/components/Mobile/KPIs/Performance/PerformanceTables/PerfTopLocationOverview.vue'
  );

const PerformanceTopLocSummary = () =>
  import(
    '@/components/Mobile/KPIs/Performance/PerformanceTables/PerfTopLocationSummary.vue'
  );

const PerfErrors = () =>
  import(
    '@/components/Mobile/KPIs/Performance/PerformanceTables/Errors/PerfErrors.vue'
  );

const PerfErrorEvents = () =>
  import(
    '@/components/Mobile/KPIs/Performance/PerformanceTables/Errors/PerfErrorEvents.vue'
  );

const PerfErrEventDetails = () =>
  import(
    '@/components/Mobile/KPIs/Performance/PerformanceTables/Errors/PerfErrEventDetails.vue'
  );

const UserCreation = () =>
  import(
    '@/components/Settings/userAdministration/UserCreation/UserCreation.vue'
  );

const RoleCreation = () =>
  import(
    '@/components/Settings/userAdministration/RoleCreation/RoleCreation.vue'
  );

const UserAdministration = () =>
  import('@/views/Settings/UserAdministration.vue');

const LicenseManagement = () =>
  import('@/views/Settings/LicenseManagement.vue');

const Notifications = () => import('@/views/Settings/Notifications.vue');

const Instance = () => import('@/views/APM/Instance.vue');

const InstanceTab = () =>
  import('@/components/APM/Dashboard/Instance/InstanceTab.vue');

const DotNetProfilerGraphs = () =>
  import(
    '@/components/APM/Dashboard/Instance/DotNetProfiler/DotNetProfilerGraphs.vue'
  );

import LoadingPage from '@/views/LoadingPage/LoadingPage.vue';
const InstanceThreads = () =>
  import('@/components/APM/Dashboard/Instance/Threads/index.vue');

const InstanceMemory = () =>
  import('@/components/APM/Dashboard/Instance/Memory/index.vue');

const InstanceSocketIO = () =>
  import('@/components/APM/Dashboard/Instance/SocketIO/index.vue');

const InstanceJVM = () =>
  import('@/components/APM/Dashboard/Instance/JvmInternals/index.vue');

const JVMGarbageCollection = () =>
  import(
    '@/components/APM/Dashboard/Instance/JvmInternals/GarbageCollection/index.vue'
  );

const JVMGcConfiguration = () =>
  import(
    '@/components/APM/Dashboard/Instance/JvmInternals/GCConfiguration/index.vue'
  );

const JVMTLABAllocations = () =>
  import(
    '@/components/APM/Dashboard/Instance/JvmInternals/TLABAllocations/index.vue'
  );
const JVMTLABThreads = () =>
  import(
    '@/components/APM/Dashboard/Instance/JvmInternals/TLABAllocations/Threads.vue'
  );
const JVMTLABTopMethods = () =>
  import(
    '@/components/APM/Dashboard/Instance/JvmInternals/TLABAllocations/TopMethods.vue'
  );
const JVMTLABClass = () =>
  import(
    '@/components/APM/Dashboard/Instance/JvmInternals/TLABAllocations/Class.vue'
  );
const JVMTLABSummary = () =>
  import(
    '@/components/APM/Dashboard/Instance/JvmInternals/TLABAllocations/Summary.vue'
  );
const InstanceMethodProfile = () =>
  import('@/components/APM/Dashboard/Instance/MethodProfile/index.vue');

const routes = [
  {
    path: '/login',
    name: 'loginIndex',
    component: IndexLogin,
    redirect: {
      name: 'login',
    },
    meta: {
      isAuth: false,
      disAllowOnAuth: true,
    },
    children: [
      {
        path: '/',
        name: 'login',
        component: Login,
      },
      {
        path: 'password-recover',
        name: 'recover',
        component: PasswordRecover,
        // meta: {
        //   isAuth: false,
        //   disAllowOnAuth: true
        // }
      },
      {
        path: 'password-reset',
        name: 'reset',
        component: PasswordReset,
        meta: {
          isAuth: false,
          disAllowOnAuth: true,
        },
      },
      {
        path: 'onboard',
        name: 'onboard',
        component: PasswordFirst,
        meta: {
          isAuth: false,
          disAllowOnAuth: true,
        },
      },
    ],
  },

  {
    path: '/',
    component: Index,
    meta: { isAuth: true },
    redirect: {
      name: 'home',
    },
    children: [
      {
        path: 'home',
        name: 'home',

        component: Home,
      },
      // Deprecating Alert V1
      /*
      path: 'alert',
        name: 'alert',
        component: Alert,
        redirect: {
          name: 'generated',
        },
        children: [
          {
            // This opens up the child components

            name: 'configured',
            path: '/configured',
            component: ConfiguredAlerts,
          },
          {
            // This opens up the child components
            name: 'generated',
            path: '/generated',
            component: GeneratedAlerts,
          },
          {
            // This opens up the child components

            name: 'channels',
            path: '/channels',
            component: NotificationChannels,
          },
        ],
      },
      */

      {
        path: 'loading-page',
        name: 'loadingPage',
        component: LoadingPage,
        meta: {
          isAuth: false,
          disAllowOnAuth: true,
        },
      },
      {
        path: 'loading-page',
        name: 'loadingPage',
        component: LoadingPage,
      },

      {
        path: 'alertsV2',
        name: 'alertsV2',
        component: AlertsV2,
        redirect: {
          name: 'generatedV2',
        },
        children: [
          {
            name: 'configuredV2',
            path: 'configuredV2',
            component: ConfiguredAlertsV2,
          },
          {
            name: 'generatedV2',
            path: 'generatedV2',
            component: GeneratedAlertsV2,
          },
          {
            name: 'tagGroupingV2',
            path: 'tagGroupingV2',
            component: TagGrouping,
          },
          {
            name: 'extTagGroupingV2',
            path: 'extTagGroupingV2',
            component: ExternalTagGrouping,
          },
        ],
      },
      {
        path: 'notification',
        name: 'notification',
        component: NotificationChannelsV2,
        redirect: {
          name: 'channel',
        },
        children: [
          {
            name: 'channel',
            path: 'channel',
            component: NotificationChannelsV2,
          },
        ],
      },
      {
        path: 'apm',
        name: 'apm',
        redirect: {
          name: 'dashboard',
        },
        component: Apm,
        children: [
          {
            // This opens up the child components

            name: 'dashboard',
            path: 'dashboard',
            component: Dashboard,
            redirect: {
              name: 'service',
            },
            children: [
              {
                name: 'service',
                path: 'service',
                component: DashboardService,
              },
              {
                name: 'appdb',
                path: 'appdb',
                component: DashboardAppDb,
                redirect: {
                  name: 'overall',
                },
                children: [
                  {
                    name: 'overall',
                    path: 'overall',
                    component: OverallInstance,
                  },
                  { name: 'query', path: 'query', component: QueryInstance },
                ],
              },
              {
                name: 'endpoint',
                path: 'endpoint',
                redirect: {
                  name: 'endpointTable',
                },
                component: DashboardEndpointView,
                children: [
                  {
                    name: 'endpointTable',
                    path: 'endpoint-table',
                    component: DashboardEndpointTableView,
                  },
                  {
                    name: 'endpointGraph',
                    path: 'endpoint-graph',
                    component: DashboardEndpointGraphsView,
                  },
                ],
              },
              {
                name: 'instance',
                path: 'instance',
                redirect: {
                  name: 'instanceTable',
                },
                component: Instance,
                children: [
                  {
                    name: 'instanceTable',
                    path: '',
                    component: DashboardInstanceTableView,
                  },
                  {
                    name: 'instanceGraph',
                    path: ':instanceId',
                    component: InstanceTab,
                    redirect: {
                      name: 'instancePerformance',
                    },
                    children: [
                      {
                        name: 'instancePerformance',
                        path: 'instance-performance',
                        component: DashboardInstanceGraphsView,
                        meta: {
                          tab: 'instancePerformance',
                        },
                      },
                      {
                        name: 'dotNetInstanceMemory',
                        path: 'dotNet-instance-memory',
                        component: DotNetProfilerGraphs,
                        meta: {
                          tab: 'dotNetInstanceMemory',
                          graph: 'memory',
                        },
                      },
                      {
                        name: 'instanceLockAndThreads',
                        path: 'dotNet-instance-lock-threads',
                        component: DotNetProfilerGraphs,
                        meta: {
                          tab: 'instanceLockAndThreads',
                          graph: 'lockAndThreads',
                        },
                      },
                      {
                        name: 'instanceLoading',
                        path: 'dotNet-instance-loading',
                        component: DotNetProfilerGraphs,
                        meta: {
                          tab: 'instanceLoading',
                          graph: 'loading',
                        },
                      },
                      {
                        name: 'instanceExceptions',
                        path: 'dotNet-instance-exceptions',
                        component: DotNetProfilerGraphs,
                        meta: {
                          tab: 'instanceExceptions',
                          graph: 'exceptions',
                        },
                      },
                      {
                        name: 'instanceInterops',
                        path: 'dotNet-instance-interops',
                        component: DotNetProfilerGraphs,
                        meta: {
                          tab: 'instanceInterops',
                          graph: 'interops',
                        },
                      },
                      {
                        name: 'instanceJIT',
                        path: 'dotNet-instance-jit',
                        component: DotNetProfilerGraphs,
                        meta: {
                          tab: 'instanceJIT',
                          graph: 'jit',
                        },
                      },
                      {
                        name: 'instanceNetworking',
                        path: 'dotNet-instance-networking',
                        component: DotNetProfilerGraphs,
                        meta: {
                          tab: 'instanceNetworking',
                          graph: 'networking',
                        },
                      },
                      {
                        name: 'instanceSecurity',
                        path: 'dotNet-instance-security',
                        component: DotNetProfilerGraphs,
                        meta: {
                          tab: 'instanceSecurity',
                          graph: 'security',
                        },
                      },
                      {
                        name: 'instanceThreads',
                        path: 'instance-threads',
                        component: InstanceThreads,
                        meta: {
                          tab: 'instanceThreads',
                        },
                      },
                      {
                        name: 'instanceMemory',
                        path: 'instance-memory',
                        component: InstanceMemory,
                        meta: {
                          tab: 'instanceMemory',
                        },
                      },
                      {
                        name: 'instanceSocketIO',
                        path: 'instance-socketIO',
                        component: InstanceSocketIO,
                        meta: {
                          tab: 'instanceSocketIO',
                        },
                      },
                      {
                        name: 'instanceJVM',
                        path: 'instance-jvm',
                        component: InstanceJVM,
                        redirect: {
                          name: 'garbageCollection',
                        },
                        children: [
                          {
                            name: 'garbageCollection',
                            path: 'garbageCollection',
                            component: JVMGarbageCollection,
                            meta: {
                              tab: 'garbageCollection',
                              parentTab: 'instanceJVM',
                            },
                          },
                          {
                            name: 'gcConfiguration',
                            path: 'gcConfiguration',
                            component: JVMGcConfiguration,
                            meta: {
                              tab: 'gcConfiguration',
                              parentTab: 'instanceJVM',
                            },
                          },
                          {
                            name: 'tlabAllocations',
                            path: 'tlabAllocations',
                            component: JVMTLABAllocations,
                            redirect: {
                              name: 'threads',
                            },
                            meta: {
                              tab: 'tlabAllocations',
                              parentTab: 'instanceJVM',
                            },
                            children: [
                              {
                                name: 'threads',
                                path: 'threads',
                                component: JVMTLABThreads,
                                meta: {
                                  tab: 'threads',
                                  parentTab: 'tlabAllocations',
                                  grandParentTab: 'instanceJVM',
                                },
                              },
                              {
                                name: 'topMethods',
                                path: 'topMethods',
                                component: JVMTLABTopMethods,
                                meta: {
                                  tab: 'topMethods',
                                  parentTab: 'tlabAllocations',
                                  grandParentTab: 'instanceJVM',
                                },
                              },
                              {
                                name: 'class',
                                path: 'class',
                                component: JVMTLABClass,
                                meta: {
                                  tab: 'class',
                                  parentTab: 'tlabAllocations',
                                  grandParentTab: 'instanceJVM',
                                },
                              },
                              {
                                name: 'summary',
                                path: 'summary',
                                component: JVMTLABSummary,
                                meta: {
                                  tab: 'summary',
                                  parentTab: 'tlabAllocations',
                                  grandParentTab: 'instanceJVM',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        name: 'instanceMethodProfile',
                        path: 'instance-method-profile',
                        component: InstanceMethodProfile,
                        meta: {
                          tab: 'instanceMethodProfile',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                name: 'infra',
                path: 'infra',
                redirect: {
                  name: 'infraTable',
                },
                component: DashboardInfraView,
                children: [
                  {
                    name: 'infraTable',
                    path: 'instances',
                    component: DashboardInfraTableView,
                  },
                  {
                    name: 'infraDetails',
                    path: 'instance',
                    component: DashboardInfraDetails,
                  },
                ],
              },
            ],
          },
          {
            // This opens up the child components
            name: 'topology',
            path: 'topology',
            component: Topology,
          },
          {
            // This opens up the child components

            name: 'trace',
            path: 'trace',
            component: Trace,
          },
          {
            // This opens up the child components

            name: 'profile',
            path: 'profile',
            component: Profile,
          },
        ],
      },
      {
        path: 'database',
        name: 'database',
        component: Database,
      },
      {
        path: 'browser',
        name: 'browser',
        component: Browser,
        redirect: {
          name: 'application',
        },
        children: [
          {
            // This opens up the child components
            name: 'application',
            path: 'application',
            component: BrowserApplication,
          },
          {
            name: 'errors',
            path: 'errors',
            component: BrowserErrors,
            redirect: {
              name: 'errorTable',
            },
            children: [
              {
                name: 'errorTable',
                path: '',
                component: BrowserErrosTable,
              },
              {
                name: 'eventsTable',
                path: 'events',
                component: BrowserEventsTable,
              },
              {
                name: 'eventDetails',
                path: 'events/details',
                component: BrowserSummary,
              },
            ],
          },
          {
            name: 'pages',
            path: 'pages',
            component: BrowserPages,
            redirect: {
              name: 'pagesTable',
            },
            children: [
              {
                name: 'pagesTable',
                path: 'pages-table',
                component: BrowserPagesTable,
              },
              {
                name: 'pagesGraph',
                path: 'pages-graph',
                component: BrowserPagesGraphs,
              },
            ],
          },
        ],
      },
      {
        path: 'usages',
        name: 'usages',
        component: Usage,
        redirect: {
          name: 'usageDashboard',
        },
        children: [
          {
            name: 'usageDashboard',
            path: 'usageDashboard',
            component: UsageDashboard,
          },
          {
            name: 'licenseUsage',
            path: 'licenseUsage',
            component: LicenseUsage,
            redirect: {
              name: 'licenseOverview',
            },
            children: [
              {
                name: 'licenseOverview',
                path: 'license-overview',
                component: LicenseOverview,
              },
              {
                name: 'licenseDatasetLevel',
                path: 'license-dataset-level',
                component: LicenseDatasetLevel,
              },
              {
                name: 'licenseSessionLevel',
                path: 'license-session-level',
                component: LicenseSessionLevel,
              },
              {
                name: 'licenseEndpointLevel',
                path: 'license-endpoint-level',
                component: LicenseEndpointLevel,
              },
            ],
          },
        ],
      },
      {
        path: 'settings',
        name: 'settings',
        component: Settings,
        redirect: {
          name: 'general',
        },
        children: [
          {
            // This opens up the child components
            name: 'general',
            path: 'general',
            component: GeneralSettings,
            redirect: {
              name: 'token',
            },
            children: [
              {
                // This opens up the child components
                name: 'token',
                path: 'token',
                component: GeneralToken,
              },
              {
                name: 'account',
                path: 'account',
                component: GeneralAccount,
              },
              {
                name: 'timezone',
                path: 'timezone',
                component: GeneralTimezone,
              },
            ],
          },
          {
            // This opens up the child components
            name: 'serviceSettings',
            path: 'serviceSettings',
            component: ServiceSettings,
            redirect: {
              name: 'transactionNaming',
            },
            children: [
              {
                // This opens up the child components
                name: 'apdexConfig',
                path: 'apdexConfig',
                component: ApdexConfig,
              },
              {
                // This opens up the child components
                name: 'dataRetentionConfig',
                path: 'dataRetentionConfig',
                component: DataRetentionConfig,
                children: [
                  {
                    // This opens up the child components
                    name: 'traceRetentionConf',
                    path: 'traceRetentionConf',
                    component: TraceRetentionConfig,
                    meta: {
                      parent: 'dataRetentionConfig',
                    },
                  },
                  {
                    // This opens up the child components
                    name: 'dbQueryConf',
                    path: 'dbQueryConf',
                    component: DBQueryConfig,
                    meta: {
                      parent: 'dataRetentionConfig',
                    },
                  },
                ],
              },
              {
                name: 'transactionNaming',
                path: 'transactionNaming',
                component: TransactionNaming,
              },
              {
                name: 'transactionExclusion',
                path: 'transactionExclusion',
                component: TransactionExclusion,
              },
              {
                name: 'codeProfileConfig',
                path: 'codeProfileConfig',
                component: CodeProfileComp,
                redirect: {
                  name: 'settingActiveCodeProfiler',
                },
                children: [
                  {
                    name: 'settingActiveCodeProfiler',
                    path: 'active-code-profiler',
                    component: CodeProfileTable,
                    meta: {
                      parent: 'codeProfileConfig',
                    },
                  },
                  {
                    name: 'settingInActiveCodeProfiler',
                    path: 'inactive-code-profiler',
                    component: CodeProfileTable,
                    meta: {
                      parent: 'codeProfileConfig',
                    },
                  },
                ],
              },
            ],
          },
          {
            // This opens up the child components
            name: 'userAdmin',
            path: 'userAdmin',
            component: UserAdministration,
            redirect: {
              name: 'userCreation',
            },
            children: [
              {
                // This opens up the child components
                name: 'userCreation',
                path: 'user-creation',
                component: UserCreation,
              },
              {
                // This opens up the child components
                name: 'roleCreation',
                path: 'role-creation',
                component: RoleCreation,
              },
            ],
          },
          {
            name: 'customQueryOverview',
            path: 'customQueryOverview',
            component: CustomQuery,
          },
          {
            // This opens up the child components
            name: 'licenseManagement',
            path: 'licenseManagement',
            component: LicenseManagement,
          },
          {
            // This opens up the child components
            name: 'notifications',
            path: 'notifications',
            component: Notifications,
          },
        ],
      },
      vmRoutes,
      {
        path: 'mobile',
        name: 'mobile',
        component: MOBILE,
        redirect: {
          name: 'mblDashboard',
        },
        children: [
          {
            // This opens up the child components
            name: 'mblDashboard',
            path: 'mblDashboard',
            component: MblDashboard,
          },
          {
            // This opens up the child components
            name: 'kpis',
            path: 'kpis',
            component: KPIs,
            redirect: {
              name: 'usage',
            },
            children: [
              {
                name: 'usage',
                path: 'usage',
                component: UsageKPIs,
                redirect: {
                  name: 'usageGraphs',
                },
                children: [
                  {
                    name: 'usageGraphs',
                    path: '',
                    component: usageGraphs,
                  },
                ],
              },
              {
                name: 'crashes',
                path: 'crashes',
                component: CrashKPIs,
                redirect: {
                  name: 'crashesGraphs',
                },
                children: [
                  {
                    // This opens up the child components
                    name: 'crashesOverview',
                    path: 'crashes-overview',
                    component: crashesOverview,
                  },
                  {
                    // This opens up the child components
                    name: 'crashesEventsOverview',
                    path: 'crashes-overview/events',
                    component: crashesEventsOverview,
                  },
                  {
                    // This opens up the child components
                    name: 'crashesEventSummary',
                    path: 'crashes-overview/events/summary',
                    component: crashesEventSummary,
                  },
                  {
                    // This opens up the child components
                    name: 'crashesGraphs',
                    path: '',
                    component: crashesGraphs,
                  },
                  {
                    // This opens up the child components
                    name: 'crashesTopOverview',
                    path: 'crashes-top',
                    component: CrashesTopOverview,
                  },
                  {
                    // This opens up the child components
                    name: 'crashesTopSummary',
                    path: 'crashes-top/summary',
                    component: CrashesTopLocSummary,
                  },
                ],
              },
              {
                name: 'performance',
                path: 'performance',
                component: PerformanceKPIs,
                redirect: {
                  name: 'performanceGraphs',
                },
                children: [
                  {
                    // This opens up the child components
                    name: 'performanceGraphs',
                    path: '',
                    component: performanceGraphs,
                  },
                  {
                    // This opens up the child components
                    name: 'httpReqOverview',
                    path: 'http-req-overview',
                    component: httpReqOverview,
                  },
                  {
                    // This opens up the child components
                    name: 'httpRequestsSummary',
                    path: 'http-req-overview/summary',
                    component: httpRequestsSummary,
                  },

                  {
                    // This opens up the child components
                    name: 'performanceTopverview',
                    path: 'performance-top',
                    component: PerfTopLocationsOverview,
                  },
                  {
                    // This opens up the child components
                    name: 'performanceTopLocSummary',
                    path: 'performance-top-location/summary',
                    component: PerformanceTopLocSummary,
                  },
                  {
                    // This opens up the child components
                    name: 'perfErrors',
                    path: 'errors',
                    component: PerfErrors,
                  },
                  {
                    // This opens up the child components
                    name: 'perfErrorEvents',
                    path: 'errors/events',
                    component: PerfErrorEvents,
                  },
                  {
                    // This opens up the child components
                    name: 'perfErrEventDetails',
                    path: 'errors/events/details',
                    component: PerfErrEventDetails,
                  },
                ],
              },
            ],
          },
        ],
      },

      k8mRoutes,
      ...integrations,
      ...cloud,
      // {
      //   path: 'wsm',
      //   name: 'wsm',
      //   component: WSM
      // },
      smRoutes,
      logRoutes,
      analyticsRoutes,
      DERoutes,
      mqRoutes,
      commonRoutes,
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes,
  // linkExactActiveClass: 'active'
});
//router.beforeEach(initCurrentUserStateMiddleware);
router.beforeEach(checkAccessMiddleware);
router.beforeEach(checkUserPermission);
router.beforeEach(checkServicePermission);
export default router;
